(function () {
  'use strict';

  function initCard(card) {
    var images = Array.from(card.querySelectorAll('.fp-product-card__image'));
    var dots   = Array.from(card.querySelectorAll('.fp-product-card__dot'));
    var prev   = card.querySelector('.fp-product-card__arrow--prev');
    var next   = card.querySelector('.fp-product-card__arrow--next');

    if (images.length < 2) return;

    var current = 0;

    function goTo(index) {
      var n = images.length;
      index = Math.max(0, Math.min(index, n - 1));

      images[current].classList.remove('fp-product-card__image--active');
      if (dots[current]) dots[current].classList.remove('fp-product-card__dot--active');

      current = index;

      images[current].classList.add('fp-product-card__image--active');
      if (dots[current]) dots[current].classList.add('fp-product-card__dot--active');

      if (prev) prev.disabled = current === 0;
      if (next) next.disabled = current === n - 1;
    }

    if (prev) {
      prev.addEventListener('click', function (e) { e.preventDefault(); goTo(current - 1); });
    }
    if (next) {
      next.addEventListener('click', function (e) { e.preventDefault(); goTo(current + 1); });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) { e.preventDefault(); goTo(i); });
    });

    goTo(0);
  }

  function initAll() {
    document.querySelectorAll('.fp-product-card--has-gallery').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init after Shopify section re-renders in Theme Editor */
  document.addEventListener('shopify:section:load', function () {
    initAll();
  });
})();
